module.exports = __webpack_public_path__ + "img/6-7.eb21f7b0.png";